import { render, staticRenderFns } from "./df-pdf-viewer.vue?vue&type=template&id=1ad0da0a"
import script from "./df-pdf-viewer.ts?vue&type=script&lang=ts&external"
export * from "./df-pdf-viewer.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports